<template>
  <div>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner styleGeneral">
            <div class="form-group row justify-content-start">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.gnrl') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">Email document</label>
            <label class="label-switch">
              <input type="checkbox" class="checkboxDefaultNegotiationAllowed" @change="changeSwitchNotifEmail" :disabled="canSwitchNotifEmail()" :checked="settings.notif_mail_rcv_doc === '1'" v-bind:value="settings.notif_mail_rcv_doc">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.ngttn_as_dflt') }}</label>
            <label class="label-switch">
              <input type="checkbox" class="checkboxDefaultNegotiationAllowed" @change="changeSwitchDefaultNegotiationAllowed" :disabled="canSwitchDefaultNegotiation()" :checked="settings.defaultNegotiationAllowed === '1'" v-bind:value="settings.defaultNegotiationAllowed">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" :disabled="canSwitchOcrActivation()" :checked="settings.ocrActivation === '1'" v-bind:value="settings.ocrActivation">
              <div class="checkbox"></div>
            </label>
          </div>
          <!-- <div class="form-group ">
            <label class="col-form-label">{{ $t('settings.ntfy_rcvr_by_eml') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxEmailRcv" @change="switchEmailRcv" :disabled="canSwitchEmailRcv()" :checked="settings.emailForRcv === '1'" v-bind:value="settings.emailForRcv">
              <div class="checkbox"></div>
            </label>
          </div> -->
        </div>
      </div>
    </ul>

    <hr v-if="hasReminderRight()">

    <ul v-if="hasReminderRight()">
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.reminder') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.default_reminder_acceptation_active') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxDefaultReminderAcceptationActive" @change="changeSwitchDefaultReminderAcceptationActive" :disabled="canSwitchReminderSettings()" :checked="settings.defaultReminderAcceptationActive === '1'" v-bind:value="settings.defaultReminderAcceptationActive">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.days_before_reminder_acceptation') }}</label>
            <div class="" style="text-align: right;">{{ settings.daysBeforeReminderAcceptation }}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="1" max="30" value="30" step="1" :disabled="canSwitchDaysReminderAcceptation()" v-model="settings.daysBeforeReminderAcceptation">
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.days_between_reminder_acceptation') }}</label>
            <div class="" style="text-align: right;">{{ settings.daysBetweenReminderAcceptation }}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="1" max="30" value="30" step="1" :disabled="canSwitchDaysReminderAcceptation()" v-model="settings.daysBetweenReminderAcceptation">
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.max_number_reminder_acceptation') }}</label>
            <div class="" style="text-align: right;">{{ settings.maxNumberReminderAcceptation }}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="10" value="0" step="1" :disabled="canSwitchDaysReminderAcceptation()" v-model="settings.maxNumberReminderAcceptation">
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.default_reminder_payment_active') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxDefaultReminderPaymentActive" @change="changeSwitchDefaultReminderPaymentActive" :disabled="canSwitchReminderSettings()" :checked="settings.defaultReminderPaymentActive === '1'" v-bind:value="settings.defaultReminderPaymentActive">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.days_before_reminder_payment') }}</label>
            <div class="" style="text-align: right;">{{ settings.daysBeforeReminderPayment }}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="1" max="30" value="0" step="1" :disabled="canSwitchDaysReminderPayment()" v-model="settings.daysBeforeReminderPayment">
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.days_between_reminder_payment') }}</label>
            <div class="" style="text-align: right;">{{ settings.daysBetweenReminderPayment }}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="1" max="30" value="30" step="1" :disabled="canSwitchDaysReminderPayment()" v-model="settings.daysBetweenReminderPayment">
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.max_number_reminder_payment') }}</label>
            <div class="" style="text-align: right;">{{ settings.maxNumberReminderPayment }}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="10" value="0" step="1" :disabled="canSwitchDaysReminderPayment()" v-model="settings.maxNumberReminderPayment">
          </div>
        </div>
      </div>
    </ul>

    <hr>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.othr') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.allwys_accpt_documents') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxAutoAcceptPayment" @change="changeSwitchAutoAcceptDocument" :disabled="canSwitchAutoAcceptDocument()" :checked="settings.accept_documents === '1'" v-bind:value="settings.accept_documents">
              <div class="checkbox"></div>
            </label>
          </div>
        </div>
      </div>
    </ul>

  </div>
</template>

<script>
export default {
  props: ['settings'],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id)
    }
  },
  created () {
  },
  mounted () {
    // expand all menus
    let that = this
    Array.prototype.forEach.call(this.Dom7('.accordion-item').addClass('accordion-item-expanded'), item => {
      that.Dom7(item).addClass('accordion-item-expanded')
    })
    Array.prototype.forEach.call(this.Dom7('.createInvoiceBand'), item => {
      that.Dom7(item).find('i').transform('rotate(90deg)')
    })
    // this.Dom7('.accordion-item').addClass('accordion-item-expanded').forEach(item => {
    //   that.Dom7(item).addClass('accordion-item-expanded')
    // })
    // this.Dom7('.createInvoiceBand').forEach(item => {
    //   that.Dom7(item).find('i').transform('rotate(90deg)')
    // })
  },
  computed: {
    sliderColorClass () {
      // let fromIdServiceToSliderClass = {
        // '1': 'RTP-slider',
        // '2': 'DD-slider',
        // '6': 'DP-slider'
      // }
      // return fromIdServiceToSliderClass[this.$engine.user.currentService.id]
      return 'RTP-slider'
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    canSwitchNotifEmail () {
      return this.$engine.rights.rightIs('ds_settings_unit_send_email', false)
    },
    changeSwitchNotifEmail (obj) {
      this.settings.notif_mail_rcv_doc = obj.target.checked ? '1' : '0'
    },
    canSwitchDefaultNegotiation () {
      return this.$engine.rights.rightIs('ds_settings_unit_nego_allowed', false)
    },
    changeSwitchDefaultNegotiationAllowed (obj) {
      this.settings.defaultNegotiationAllowed = obj.target.checked ? '1' : '0'
    },
    canSwitchOcrActivation () {
      return this.$engine.rights.rightIs('ds_settings_unit_ocr_activation', false)
    },
    changeSwitchOcrActivation (obj) {
      this.settings.ocrActivation = obj.target.checked ? '1' : '0'
    },
    canSwitchAutoAcceptDocument () {
      return this.$engine.rights.rightIs('ds_settings_unit_auto_accept', false)
    },
    // checkboxAutoAcceptPayment change event
    changeSwitchAutoAcceptDocument (obj) {
      this.settings.auto_accept_document = obj.target.checked ? '1' : '0'
    },
    canSwitchReminderSettings () {
      return this.$engine.rights.rightIs('ds_reminder', false)
    },
    canSwitchDaysReminderAcceptation () {
      return this.settings.defaultReminderAcceptationActive === '0'
    },
    changeSwitchDefaultReminderAcceptationActive (obj) {
      this.settings.defaultReminderAcceptationActive = obj.target.checked ? '1' : '0'
    },
    canSwitchDaysReminderPayment () {
      return this.settings.defaultReminderPaymentActive === '0'
    },
    changeSwitchDefaultReminderPaymentActive (obj) {
      this.settings.defaultReminderPaymentActive = obj.target.checked ? '1' : '0'
    },
    hasReminderRight () {
      return (this.$engine.user.get().rights.ds_reminder === '1')
    }
  }
}
</script>
<style>
.styleGeneral:hover {
  text-decoration: underline;
  text-decoration-color: #51a45c;
}
</style>
